import React from 'react';

const Back = (props: { className?: string }) => {
    return (
        <svg
            className={props.className}
            xmlns='http://www.w3.org/2000/svg'
            width='20'
            height='20'
            viewBox='0 0 20 20'
            fill='none'>
            <path
                d='M4 4L16 16M16 4L4 16'
                stroke='currentColor'
                strokeWidth='2'
                strokeLinecap='round'
                strokeLinejoin='round'
            />
        </svg>
    );
};

export default Back;
